import { default as localeCustomizations } from './locales'
import { default as containerCustomizations } from './customizations'
import { IPartnerConfig } from '../../internal'

import logoLight from './assets/simpleaccess-logo.svg';
import logoDark from './assets/simpleaccess-logo-dark-mode.svg';

// import logoLight from './assets/truesecure-logo.svg';
// import logoDark from './assets/truesecure-logo-dark-mode.svg';

// must export all of these for each partner. Empty if using defaults
const partnerCustomizations: IPartnerConfig = {
  assets: {
    logoOnBackground: logoLight,
    logoOnSecondary: logoLight,
    logoOnPrimary: logoDark,
    logoOnDark: logoDark,
  },
  locales: localeCustomizations,
  containers: containerCustomizations,
}
export default partnerCustomizations;